'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = require('react');
var React__default = _interopDefault(React);
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var componentsScrollcontainer = require('@keytrade/components-scrollcontainer');
var componentsTitletooltip = require('@keytrade/components-titletooltip');
var PropTypes = _interopDefault(require('prop-types'));
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.4rem",
    height: "2.4rem",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M8.177 11.88l5.89 5.844a.597.597 0 0 0 .85 0l.355-.358a.609.609 0 0 0 0-.856l-5.115-5.06 5.11-5.058a.609.609 0 0 0 0-.857l-.355-.357a.597.597 0 0 0-.85 0l-5.89 5.845c-.23.236-.23.62.005.856z"
  }));
};
var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.4rem",
    height: "2.4rem",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M16.271 11.88l-5.89 5.844a.597.597 0 0 1-.85 0l-.355-.358a.609.609 0 0 1 0-.856l5.115-5.06-5.11-5.058a.609.609 0 0 1 0-.857l.355-.357a.597.597 0 0 1 .85 0l5.89 5.845c.23.236.23.62-.005.856z"
  }));
};
var colors = functions.config.colors.list;
var getFont = functions.config.fonts.getFont;
var TabsWrapper = styled.div.withConfig({
  displayName: "Tabsstyled__TabsWrapper",
  componentId: "sc-dvzhbl-0"
})(["margin:", ";"], function (props) {
  return props.margin;
});
var TabHeaderWrapper = styled.nav.withConfig({
  displayName: "Tabsstyled__TabHeaderWrapper",
  componentId: "sc-dvzhbl-1"
})(["min-height:4rem;", " background-color:", ";overflow:hidden;", ""], function (props) {
  return props.type === 'dark' ? 'border-radius: .4rem;' : null;
}, function (props) {
  return props.type === 'dark' ? colors.BlueMoon : 'transparent';
}, function (props) {
  return props.type === 'pills' && (props.withBorder ? props.colorScheme === 'lightInverted' ? "border-bottom: 1px solid ".concat(colors.White, ";") : "border-bottom: 1px solid ".concat(colors.BlueLight, ";") : null);
});
var TabHeader = styled.ul.withConfig({
  displayName: "Tabsstyled__TabHeader",
  componentId: "sc-dvzhbl-2"
})(["margin:0;padding:", ";list-style-type:none;display:flex;justify-content:flex-start;", " ", ""], function (props) {
  return props.type === 'pills' ? '3.2rem 0' : '0';
}, function (_ref) {
  var wrap = _ref.wrap;
  return wrap && 'flex-wrap: wrap;';
}, function (props) {
  return props.type === 'pills' && props.colorScheme === 'lightInverted' && props.wrap ? "gap: 12px 8px; " : '0;';
});
var TabItem = styled.li.withConfig({
  displayName: "Tabsstyled__TabItem",
  componentId: "sc-dvzhbl-3"
})(["display:inline;position:relative;", " &:disabled:hover,&:disabled{cursor:not-allowed;pointer-events:none;}> div > span{display:block;min-width:1px;min-height:1px;position:absolute;z-index:10;left:0;top:0;bottom:0;right:0;cursor:not-allowed;}"], function (props) {
  return props.type === 'light' && "\n    &:first-child button {\n      padding-left: 0;\n    }\n\n    &:last-child button {\n      padding-right: 0;\n    }\n  ";
});
var TabItemButton = styled.button.attrs({
  className: 'tab-item-button'
}).withConfig({
  displayName: "Tabsstyled__TabItemButton",
  componentId: "sc-dvzhbl-4"
})(["padding:", ";font-size:", ";line-height:1.6rem;border:none;", " ", " background-color:", ";color:", ";cursor:", ";transition:color 0.2s ease,background-color 0.2s ease;white-space:nowrap;&:focus,& > *:focus{outline:none;}&:not([disabled]):hover,&:not([disabled]):focus{color:", ";", ";}&:disabled:hover,&:disabled{cursor:not-allowed;}font-family:", ";"], function (props) {
  return props.type === 'pills' ? '1rem 2rem' : '0.6rem 1.6rem';
}, function (props) {
  switch (props.type) {
    case 'light':
      return '1.4rem';
    case 'dark':
      return '1.2rem';
    case 'pills':
      return '1.6rem';
  }
}, function (props) {
  return props.type === 'pills' && "border-radius: 2.4rem;";
}, function (props) {
  return props.type === 'pills' && props.colorScheme === 'lightInverted' && props.wrap && !props.active && "border: 1px solid ".concat(colors.BlueFog, "B0 !important;");
}, function (props) {
  switch (props.type) {
    case 'light':
      return 'transparent';
    case 'dark':
      return props.active ? colors.BlueDark : colors.BlueMoon;
    case 'pills':
      if (props.active) {
        return props.colorScheme === 'light' ? colors.BlueLight : colors.White;
      }
      return 'transparent';
  }
}, function (props) {
  switch (props.type) {
    case 'light':
      return props.disabled ? colors.GreyMedium : props.active ? colors.BlueSky : colors.GreyDark;
    case 'dark':
      return props.disabled ? colors.BlueCloudy : colors.White;
    case 'pills':
      return props.disabled ? colors.GreyMedium : props.active ? colors.BlueSky : props.colorScheme === 'dark' ? colors.White : colors.BlueDark;
  }
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  switch (props.type) {
    case 'light':
      return colors.BlueSky;
    case 'dark':
      return colors.White;
    case 'pills':
      return props.active ? colors.BlueSky : props.colorScheme === 'dark' ? colors.BlueCloudy : colors.GreyBlue;
  }
}, function (props) {
  return props.type === 'dark' && "background-color: ".concat(colors.BlueDark);
}, function (props) {
  return props.theme.fontFamily ? props.theme.fontFamily : getFont(props.theme, props.type === 'dark' ? 'bold' : 'semiBold');
});
var TabItemInner = styled.div.withConfig({
  displayName: "Tabsstyled__TabItemInner",
  componentId: "sc-dvzhbl-5"
})(["", " ", " font-family:inherit;"], function (props) {
  return props.type !== 'pills' && 'padding: .6rem 0;';
}, function (props) {
  return props.type === 'light' && "\n    border-bottom: .2rem solid ".concat(props.active ? colors.BlueSky : 'transparent', ";\n  ");
});
var TabContent = styled.div.withConfig({
  displayName: "Tabsstyled__TabContent",
  componentId: "sc-dvzhbl-6"
})(["position:relative;font-family:inherit;"]);
var TabContentInner = styled.div.withConfig({
  displayName: "Tabsstyled__TabContentInner",
  componentId: "sc-dvzhbl-7"
})(["position:relative;", " font-family:inherit;"], function (props) {
  return props.type === 'pills' && 'line-height: 20px;';
});
var ScrollButton = styled.button.withConfig({
  displayName: "Tabsstyled__ScrollButton",
  componentId: "sc-dvzhbl-8"
})(["position:absolute;z-index:10;top:50%;transform:translateY(-50%);", " ", " width:2.4rem;height:100%;max-height:43px;padding:0.9rem 0;border:none;border-radius:.4rem;background-color:", ";cursor:pointer;&:focus{outline:none;}"], function (props) {
  return props.left ? 'left: 0;' : null;
}, function (props) {
  return props.left ? null : 'right: 0;';
}, function (props) {
  switch (props.bgColor) {
    case 'transparent':
      return 'transparent';
    case 'cms':
      return colors.BlueLight;
    case 'custom':
      return props.bgColorCustom ? props.bgColorCustom : props.type === 'dark' ? colors.BlueMoon : colors.White;
    case 'default':
    default:
      return props.type === 'dark' ? colors.BlueMoon : colors.White;
  }
});
var ContentWrapper = styled.div.withConfig({
  displayName: "Tabsstyled__ContentWrapper",
  componentId: "sc-dvzhbl-9"
})([""]);
var TabWrapper = styled.div.withConfig({
  displayName: "Tabsstyled__TabWrapper",
  componentId: "sc-dvzhbl-10"
})([""]);
var colors$1 = functions.config.colors.list;
var slugify = function slugify(str) {
  return str.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
};
var Tabs = /*#__PURE__*/function (_Component) {
  function Tabs(_props) {
    var _this;
    _classCallCheck(this, Tabs);
    _this = _callSuper(this, Tabs, [_props]);
    // get url anchor
    _defineProperty(_this, "getCurrentAnchor", function () {
      var url = window && window.location && window.location.href;
      var urlAnchor = url.split('#')[1];
      urlAnchor = _this.props.addHash && urlAnchor && urlAnchor.length ? urlAnchor : '-1';
      return urlAnchor;
    });
    // if url hash matches a tab, set state activeindex
    _defineProperty(_this, "initUrlActiveIndex", function (anchor) {
      if (anchor === '-1') {
        _this.setState({
          activeIndex: 0
        });
      }
      // if urlAnchor is not null and urlAnchor matches one of the state.StateTabs.slug, set activeIndex to that index
      var index = _this.state.stateTabs.findIndex(function (tab) {
        return tab.slug === anchor;
      });
      // if index is not -1 and index is not equal to activeIndex, set state activeIndex
      if (index !== -1 && index !== _this.state.activeIndex) {
        _this.setState({
          activeIndex: index
        });
      }
    });
    // at mount, check if anchor tag exist, and if true, set state activeindex
    // istanbul ignore next
    _defineProperty(_this, "componentDidMount", function () {
      var _this$props = _this.props,
        activeIndex = _this$props.activeIndex,
        data = _this$props.data;
      if (typeof window !== 'undefined') {
        _this.props.addHash && _this.getCurrentAnchor() ? _this.initUrlActiveIndex(_this.getCurrentAnchor()) : _this.setState({
          activeIndex: _this.initActiveIndex(activeIndex, data)
        });
      }
    });
    _defineProperty(_this, "areTabsEqual", function (newTabs, oldTabs) {
      if (newTabs === oldTabs) return true;
      if (newTabs.length !== oldTabs.length) return false;
      return !newTabs.some(function (newTab, index) {
        return newTab !== oldTabs[index];
      });
    });
    _defineProperty(_this, "componentDidUpdate", function (prevProps) {
      if (!_this.areTabsEqual(_this.props.data, prevProps.data) || _this.props.onTabChange && prevProps.activeIndex !== _this.props.activeIndex) {
        _this.setState({
          activeIndex: _this.initActiveIndex(_this.props.activeIndex, _this.props.data)
        });
      }
    });
    /**
     * Initialize the active index on component mount.
     * Based on the activeIndex prop and if matches the length of the data prop array.
     */
    _defineProperty(_this, "initActiveIndex", function (index, data) {
      if (index === null || index >= data.length) return 0;
      return index;
    });
    /**
     * Set a new activeIndex in the state based on the clicked tab index.
     */
    _defineProperty(_this, "onClickTab", function (index, tag, addHash) {
      var urlLocation = window.location.href;
      var url = window.location.origin + window.location.pathname + window.location.search;
      var inputParams = new URLSearchParams(urlLocation.search);
      addHash && inputParams.append('#', tag);
      if (addHash) {
        if (_this.props.onTabChange) {
          _this.props.onTabChange(_this.props.data[index].name, index, addHash);
        }
      } else {
        if (_this.props.onTabChange) {
          _this.props.onTabChange(_this.props.data[index].name, index);
        }
      }
      _this.setState({
        activeIndex: index
      });

      // add stateTabs slug to url parameters
      addHash && window.history.replaceState(null, null, "".concat(url, "#").concat(_this.state.stateTabs[index].slug));
    });
    _defineProperty(_this, "render", function () {
      var activeIndex = _this.state.activeIndex;
      var _this$props2 = _this.props,
        data = _this$props2.data,
        type = _this$props2.type,
        colorScheme = _this$props2.colorScheme,
        withBorder = _this$props2.withBorder,
        bgColor = _this$props2.bgColor,
        bgColorCustom = _this$props2.bgColorCustom,
        className = _this$props2.className,
        addHash = _this$props2.addHash,
        wrap = _this$props2.wrap;
      var _Tabs2 = data.map(function (tab, i) {
        return /*#__PURE__*/React__default.createElement(TabItem, {
          key: "".concat(i, "-").concat(tab.name),
          type: type,
          disabled: tab.disabled && tab.disabledText,
          className: className
        }, tab.disabled && tab.disabledText ? /*#__PURE__*/React__default.createElement(TabWrapper, {
          wrap: wrap
        }, /*#__PURE__*/React__default.createElement(componentsTitletooltip.TitleTooltip, {
          id: "titletooltip-".concat(i, "-").concat(tab.name),
          tip: tab.disabledText
        }), /*#__PURE__*/React__default.createElement(TabItemButton, {
          id: "tab-".concat(slugify(tab.name)),
          type: type,
          colorScheme: colorScheme,
          disabled: tab.disabled,
          wrap: wrap
        }, /*#__PURE__*/React__default.createElement(TabItemInner, {
          type: type
        }, tab.name))) : /*#__PURE__*/React__default.createElement(TabItemButton, {
          id: "tab-".concat(slugify(tab.name)),
          active: activeIndex === i,
          type: type,
          colorScheme: colorScheme,
          onClick: function onClick() {
            return _this.onClickTab(i, "tab-".concat(slugify(tab.name)), addHash);
          },
          disabled: tab.disabled,
          role: "tab",
          tabIndex: activeIndex === i ? 0 : -1,
          "aria-selected": activeIndex === i,
          "aria-controls": "tab-".concat(slugify(tab.name)),
          wrap: wrap
        }, /*#__PURE__*/React__default.createElement(TabItemInner, {
          active: activeIndex === i,
          type: type
        }, tab.name)));
      });
      var Content = data[activeIndex] && data[activeIndex].content ? /*#__PURE__*/React__default.createElement(ContentWrapper, {
        role: "tabpanel",
        "aria-selected": "true",
        "aria-labelledby": "tab-".concat(slugify(data[activeIndex].name)),
        id: "tab-".concat(slugify(data[activeIndex].name))
      }, data[activeIndex].content) : null;
      return /*#__PURE__*/React__default.createElement(TabsWrapper, {
        margin: _this.props.margin
      }, /*#__PURE__*/React__default.createElement(TabHeaderWrapper, {
        type: type,
        colorScheme: colorScheme,
        withBorder: withBorder,
        wrap: wrap
      }, /*#__PURE__*/React__default.createElement(componentsScrollcontainer.ScrollContainer, {
        button: function button(props) {
          return !props.isHidden && /*#__PURE__*/React__default.createElement(ScrollButton, _extends({
            type: type,
            bgColor: bgColor,
            bgColorCustom: bgColorCustom
          }, props), props.left ? /*#__PURE__*/React__default.createElement(ArrowLeft, {
            color: type === 'dark' || colorScheme === 'dark' ? colors$1.White : colors$1.BlueSky
          }) : /*#__PURE__*/React__default.createElement(ArrowRight, {
            color: type === 'dark' || colorScheme === 'dark' ? colors$1.White : colors$1.BlueSky
          }));
        },
        styledComponentsV4: _this.props.styledComponentsV4
      }, data.length > 0 && /*#__PURE__*/React__default.createElement(TabHeader, {
        type: type,
        colorScheme: colorScheme,
        role: "tablist",
        wrap: wrap
      }, _Tabs2))), /*#__PURE__*/React__default.createElement(TabContent, null, /*#__PURE__*/React__default.createElement(TabContentInner, null, Content)));
    });
    _this.state = {
      activeIndex: null,
      stateTabs: _props.data.map(function (tab) {
        return _objectSpread2({
          slug: slugify(tab.name)
        }, tab);
      })
    };
    return _this;
  }
  _inherits(Tabs, _Component);
  return _createClass(Tabs);
}(React.Component);
Tabs.propTypes = {
  /** Tabs headings and content */
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    content: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
    disabledText: PropTypes.string
  })).isRequired,
  /** Set the initially active item. If props.onTabChange is set, you can update this directly by passing it a new value. */
  activeIndex: PropTypes.number,
  /** Tabs styles. Consult the design documentation to know which one to use */
  type: PropTypes.oneOf(['light', 'dark', 'pills']),
  /** The "theme" to apply on the whole Tabs component. Note that this *only* applies on the type="pills" prop, and does not include the background color. */
  colorScheme: PropTypes.oneOf(['light', 'lightInverted', 'dark']),
  /** Set a function that controls when the tab changes. Has 2 parameters: (activeTab, activeIndex). When passed the component will not control its own state anymore. */
  onTabChange: PropTypes.func,
  /** this will add a margin shortcut css rule */
  margin: PropTypes.string,
  /** this will add the nav border bottom if passed, only work with the type "pill" */
  withBorder: PropTypes.bool,
  /** Set this to true if your project is using styled-components V4 or above */
  styledComponentsV4: PropTypes.bool,
  /** bgColor if set, will change the background colors to the desire value */
  bgColor: PropTypes.oneOf(['default', 'transparent', 'cms', 'custom']),
  /** bgColorCustom if set, will change overwrite the background color value, above the default of the bcColor value,, have to bee css color value (hex, rgb, rgba..) */
  bgColorCustom: PropTypes.string,
  /** addHash will deactivate the hash in the url */
  addHash: PropTypes.bool,
  /** wrap will add flex-wrap to tabs pills  */
  wrap: PropTypes.bool
};
Tabs.defaultProps = {
  activeIndex: null,
  type: 'light',
  colorScheme: 'light',
  onTabChange: undefined,
  bgColor: 'default',
  bgColorCustom: undefined,
  addHash: false,
  wrap: false
};
exports.Tabs = Tabs;